// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-core-pages-page-template-tsx" + "-" + "0e746ff3b94cc7cde92a" + ".js";
};